import useUserStore from '@/store/modules/user'

export default {
    mounted(el, binding, node) {
        const {value} = binding
        const roles = useUserStore().roles
        if (!value || value.length === 0) {
            if (el.parentNode) {
                console.log(el.parentNode)
            }
            throw new Error("未设置角色标识")
        }
        let hasRole = false
        if (value instanceof Array) {
            // 如果 value 是数组，检查用户是否有任何一个角色
            hasRole = value.some(role => roles.includes(role))
        } else {
            // 如果 value 是字符串，检查用户是否有该角色
            hasRole = roles.includes(value)
        }
        if (!hasRole) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}
